<template>
    <div class="ubicacion">
        <div id="ubicaciones" class="ancla"></div>
        <div class="content">
            <div class="titulo">
                <b-row>
                    <b-col cols="12" md>
                        <div class="linea lineaIzquierda"></div>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <p v-if="lang == 'eng'">our digital screens</p>
                        <p v-else-if="lang == 'esp'">nuestras pantallas</p>
                    </b-col>
                    <b-col cols>
                        <div class="linea lineaDerecha"></div>
                    </b-col>
                </b-row>
            </div>
            <h2 v-if="lang == 'eng'">Find the location that suits your market</h2>
            <h2 v-else-if="lang == 'esp'">Encuentra la ubicación que se adapte a tu mercado</h2>
        </div>
        <div class="slider">
            <slick ref="slick" :options="slickOptions">
                <div>
                    <img src="../assets/img/img_garita1_lg.jpg" alt="Garita">
                    <div class="text" v-if="lang == 'eng'">
                        <h5>Vehicular Digital Screen Garita Chaparral</h5>
                        <p>(Digital Screen Front-Billboard Back)</p>
                    </div>
                    <div class="text" v-else-if="lang == 'esp'">
                        <h5>Pantalla Vehicular Garita Chaparral</h5>
                        <p>(Frente electrónico - Banner impreso)</p>
                    </div>
                </div>
                <div>
                    <img src="../assets/img/img_garita2_lg.jpg" alt="Garita">
                    <div class="text" v-if="lang == 'eng'">
                        <h5>Pedestrian Digital Screen</h5>
                        <p>(Digital Screen Front-Billboard Back)</p>
                    </div>
                    <div class="text" v-else-if="lang == 'esp'">
                        <h5>Pantalla Peatonal Garita Chaparral</h5>
                        <p>(Frente electrónico - Banner impreso)</p>
                    </div>
                </div>
                <div>
                    <img src="../assets/img/img_garita3_lg.jpg" alt="Garita">
                    <div class="text" v-if="lang == 'eng'">
                        <h5>Vehicular Digital Screen Garita Otay</h5>
                        <p>(Digital Screen Front-Billboard Back)</p>
                    </div>
                    <div class="text" v-else-if="lang == 'esp'">
                        <h5>Pantalla Vehicular Garita Otay</h5>
                        <p>(Frente electrónico - Banner impreso)</p>
                    </div>
                </div>
            </slick>
        </div>
        <div class="content">
            <b-row>
                <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                    <div class="buscador">
                        <multiselect 
                            v-model="value" 
                            :show-labels="false"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            :options="options">
                            <template slot="singleLabel" slot-scope="props">
                                <div class="option__desc">
                                    <img src="static/icn_pin_orange.svg" alt="marker">
                                    <span v-if="lang == 'eng'" :class="props.option.status"><strong>{{ props.option.nameEn }}</strong> (Digital Screen Front-Billboard Back)</span>
                                    <span v-else-if="lang == 'esp'" :class="props.option.status"><strong>{{ props.option.nameEs }}</strong> (Frente electrónico - Banner impreso)</span>
                                </div>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <img :src="'static/'+props.option.icon" alt="marker">
                                    <span v-if="lang == 'eng'" :class="props.option.status"><strong>{{ props.option.nameEn }}</strong><br class="mobile"> (Digital Screen Front-Billboard Back)</span>
                                    <span v-else-if="lang == 'esp'" :class="props.option.status"><strong>{{ props.option.nameEs }}</strong><br class="mobile"> (Frente electrónico - Banner impreso)</span>
                                </div>
                            </template>
                        </multiselect>
                    </div>
                    <GmapMap
                        :center="center"
                        :zoom="15"
                        map-type-id="roadmap"
                        style="width: 100%; height: 300px"
                        >
                        <gmap-custom-marker :marker="data.marker" v-for="(data, index) in options" :key="index">
                            <img src="../assets/img/icn_pin_orange.svg" />
                        </gmap-custom-marker>
                    
                    </GmapMap>
                </b-col>
            </b-row>   
        </div>
    </div>
</template>

<script>
    import GmapCustomMarker from 'vue2-gmap-custom-marker'
    import Multiselect from 'vue-multiselect'
    import {mapState, mapActions, mapMutations} from 'vuex'
    import Slick from 'vue-slick'
    export default {
        computed:{
            ...mapState(['lang'])
        },
        components: {
            'gmap-custom-marker': GmapCustomMarker,
            Multiselect,
            Slick
        },
        watch: {
            value(newVal, oldVal) {
                this.center = newVal.marker
            }
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 1,
                    dots: false,
                    arrows: true,
                    autoplay: true,
                },
                center: {
                    lat:32.540936, 
                    lng:-117.034616
                },
                value: { 
                    nameEs: 'Pantalla Vehicular Garita Chaparral',
                    nameEn: 'Vehicular Digital Screen Chaparral Security Checkpoint',
                    marker:  {
                        lat: 32.540936,
                        lng: -117.034616
                    },
                    status: 'active', 
                    icon: 'icn_pin_blue.svg' 
                },
                options: [
                    { 
                        nameEs: 'Pantalla Vehicular Garita Chaparral', 
                        nameEn: 'Vehicular Digital Screen Chaparral Security Checkpoint',
                        marker:  {
                            lat: 32.540111,
                            lng: -117.032778
                        },
                        status: 'active', 
                        icon: 'icn_pin_blue.svg' 
                    },
                    { 
                        nameEs: 'Pantalla Peatonal Garita Chaparral', 
                        nameEn: 'Pedestrian Digital Screen Chaparral Security Checkpoint',
                        marker: {
                            lat: 32.540366,
                            lng: -117.032272
                        },
                        status: 'active', 
                        icon: 'icn_pin_blue.svg' 
                    },
                    { 
                        nameEs: 'Pantalla Vehicular Garita Otay',
                        nameEn: 'Vehicular Digital Screen Otay Checkpoint',
                        marker: {
                            lat: 32.546923,
                            lng: -116.938434
                        },
                        status: 'active', 
                        icon: 'icn_pin_blue.svg' 
                    },
                    { 
                        nameEs: 'PRÓXIMAMENTE - Pantalla Vehicular Garita Mexicali I',  
                        nameEn: 'COMING SOON - Vehicular Digital Screen Mexicali I Checkpoint',
                        marker: {
                            lat: 32.664762,
                            lng: -115.495725
                        },
                        status: 'disabled', 
                        icon: 'icn_pin_gray.svg' 
                    },
                    { 
                        nameEs: 'PRÓXIMAMENTE - Pantalla Peatonal Garita San Ysidro', 
                        nameEn: 'COMING SOON - Pedestrian Digital Screen San Ysidro Checkpoint',
                        marker: {
                            lat: 32.542444,
                            lng: -117.027417
                        },
                        status: 'disabled', 
                        icon: 'icn_pin_gray.svg' 
                    },
                ]
            }
        },
        methods: {
            next() {
                this.$refs.slick.next()
            },
            prev() {
                this.$refs.slick.prev()
            },
            reInit() {
                this.$refs.slick.reSlick()
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    .ubicacion{
        padding-top: 140px;
        position: relative;
        text-align: center;
    }
    h2{
        margin-bottom: 40px;
    }
    img{
        width: 100%;
    }
    .slider{
        margin-bottom: 80px;
    }
    .text{
        background-color: #383838;
        padding: 30px 10px;
    }
    .text *{
        color: white;
    }
    .text p{
        font-size: 10pt;
        margin-bottom: 5px;
    }
    .text h5{
        font-family: 'sailecBold';
    }
    .buscador{
        margin-bottom: 30px;
    }
    .mobile{
        display: none;
    }

    @media screen and (max-width: 767px){
        .ubicacion{
            padding-top: 100px;
        }
        .ubicacion .mobile{
            display: block;
        }
        .text h5{
            font-size: 12pt;
        }
    }
</style>

<style>
    .multiselect__tags{
        border-radius: inherit;
        border: none;
        -webkit-box-shadow: 0px 3px 15px 0px rgba(155,209,212,1);
        -moz-box-shadow: 0px 3px 15px 0px rgba(155,209,212,1);
        box-shadow: 0px 3px 15px 0px rgba(155,209,212,1);
        padding-top: 0;
        display: flex;
        align-items: center;
    }
    .multiselect__select{
        width: auto;
        height: auto;
        top: 22%;
       
    }
    .multiselect__select:before{
        content: url('../assets/img/icn_arrow.svg');
        border: none;
        width: 5px;
    }
    .multiselect__single{
        font-size: 10pt;
        margin-bottom: 0;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .multiselect__single img{
        width: 15px;
        margin-right: 12px;
    }
    .multiselect__option{
        font-size: 9pt;
    }
    .multiselect__element{
        background-color: #F5F5F5!important;
    }
    .multiselect__option--highlight{
        background-color: #e5e3e3!important;
    }
    .disabled, .disabled *{
        color: rgba(113, 113, 113, 0.3)!important;
    }
    .active, .active *, .multiselect__single *{
        color: #068C93!important;
    }
    .option__desc{
        display: flex;
        align-items: center;
    }
    .multiselect__option img{
        width: 10px;
        margin-right: 12px;
    }
    .ubicacion .slick-prev, .ubicacion .slick-next{
        width: auto;
        height: auto;
    }
    .ubicacion .slick-prev{
        left: 0;
        z-index: 99;
    }
    .ubicacion .slick-next{
        right: 0;
    }
    .ubicacion .slick-prev:before{
        content: url('../assets/img/icn_left.svg');
    }
    .ubicacion .slick-next:before{
        content: url('../assets/img/icn_right.svg');
    }

    @media screen and (max-width: 991px){
        .vue-map-container{
            height: 350px!important;
            margin-bottom: 30px;
        }
    }
    @media screen and (max-width: 767px){
        .ubicacion .slick-prev:before{
        content: url('../assets/img/icn_left_sm.svg');
    }
        .ubicacion .slick-next:before{
            content: url('../assets/img/icn_right_sm.svg');
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Ubicacion.vue